import TableLoader from "../loaders/TableLoader";
import { Tooltip } from "@mui/material";
import TablePagination from "@mui/material/TablePagination";
import { FaRegEye } from "react-icons/fa6";
import { Link } from "react-router-dom";
import noItems from "../../assets/noNotifications.svg";
import {
  APPROVAL_STATUS,
  CAMPAIGN_STATUS,
  CAMPAIGN_TYPE,
} from "../../utils/constants";
import { IoCloseOutline } from "react-icons/io5";

const CampaignsTable = ({
  isLoading,
  influencerDetails,
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,
  id,
  campaignType,
  setCampaignType,
  campaignStatus,
  setCampaignStatus,
  approvalStatus,
  setApprovalStatus,
}) => {
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const clearFiltersHandler = () => {
    setCampaignType("");
    setCampaignStatus("");
    setApprovalStatus("");
  };

  return (
    <div className="camp_influencers_main">
      <div className="d-flex justify-content-between align-items-center mb-2 mt-2">
        <h4>My Campaigns</h4>
      </div>
      <div className="row campaign_infl_filter d-flex align-items-center justify-content-between mb-3 mt-3">
        <div className="col-md-3 d-flex align-items-center">
          <select
            className="form-select"
            value={campaignType}
            onChange={(e) => setCampaignType(e.target.value)}
          >
            <option value="" disabled selected>
              Campaign Type
            </option>
            {CAMPAIGN_TYPE.map((type) => (
              <option value={type.name} key={type.name}>
                {type.label}
              </option>
            ))}
          </select>
          {campaignType && (
            <button className="ms-2" onClick={() => setCampaignType("")}>
              <IoCloseOutline />
            </button>
          )}
        </div>
        <div className="col-md-3 d-flex align-items-center">
          <select
            className="form-select"
            value={campaignStatus}
            onChange={(e) => setCampaignStatus(e.target.value)}
          >
            <option value="" disabled selected>
              Campaign Status
            </option>
            {CAMPAIGN_STATUS.map((status) => (
              <option value={status.name} key={status.name}>
                {status.label}
              </option>
            ))}
          </select>
          {campaignStatus && (
            <button className="ms-2" onClick={() => setCampaignStatus("")}>
              <IoCloseOutline />
            </button>
          )}
        </div>
        <div className="col-md-3 d-flex align-items-center">
          <select
            className="form-select"
            value={approvalStatus}
            onChange={(e) => setApprovalStatus(e.target.value)}
          >
            <option value="" disabled selected>
              Approval Status
            </option>
            {APPROVAL_STATUS.map((status) => (
              <option value={status.name} key={status.name}>
                {status.label}
              </option>
            ))}
          </select>
          {approvalStatus && (
            <button className="ms-2" onClick={() => setApprovalStatus("")}>
              <IoCloseOutline />
            </button>
          )}
        </div>
        <div className="col-md-3">
          <button onClick={clearFiltersHandler}>
            <span style={{ fontSize: "14px", marginBottom: "2px" }}>
              Clear All
            </span>{" "}
            <IoCloseOutline />
          </button>
        </div>
      </div>
      {isLoading ? (
        <TableLoader rows={6} columns={5} />
      ) : influencerDetails?.length === 0 ? (
        <div className="d-flex flex-column align-items-center justify-content-center">
          <img src={noItems} alt="no item" />
          <h4 className="no_data mt-5">There is no campaign to show</h4>
        </div>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Campaign Name</th>
              <th>Campaign Type</th>
              <th>Campaign Status</th>
              <th>Approval Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {influencerDetails?.map((campaign) => (
              <tr key={campaign?._id}>
                <td>{campaign?.campaignName}</td>
                <td>{campaign?.campaignType}</td>
                {campaign?.campaignStatus?.toLowerCase() === "active" && (
                  <td style={{ color: "#22c55e" }}>
                    {campaign?.campaignStatus}
                  </td>
                )}
                {campaign?.campaignStatus?.toLowerCase() ===
                  "not started yet" && (
                  <td style={{ color: "#a6a6a6" }}>
                    {campaign?.campaignStatus}
                  </td>
                )}
                {campaign?.campaignStatus?.toLowerCase() === "on hold" && (
                  <td style={{ color: "#ffc107" }}>
                    {campaign?.campaignStatus}
                  </td>
                )}
                {campaign?.campaignStatus?.toLowerCase() === "completed" && (
                  <td style={{ color: "#2e7d32" }}>
                    {campaign?.campaignStatus}
                  </td>
                )}
                <td>
                  {(() => {
                    const status = campaign?.appliedInfluencers?.find(
                      (infl) => infl?.influencerId?.toString() === id
                    )?.status;

                    const colorMap = {
                      pending: "#facc15",
                      approved: "#22c55e",
                      rejected: "#ef4444",
                    };

                    return (
                      <span style={{ color: colorMap[status] || "#000" }}>
                        {status?.slice(0, 1).toUpperCase() + status?.slice(1) ||
                          "-"}
                      </span>
                    );
                  })()}
                </td>

                <td>
                  <Tooltip title="View Campaign" placement="top">
                    <Link to={`/campaign-details/${campaign?._id}`}>
                      <button className="btn btn_edit p-0 ms-3">
                        <FaRegEye style={{ marginBottom: "3px" }} />
                      </button>
                    </Link>
                  </Tooltip>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {influencerDetails?.campaigns?.length > 10 && (
        <div className="mt-3 d-flex align-items-center justify-content-between">
          <div></div>
          <TablePagination
            component="div"
            count={influencerDetails?.campaigns?.length || 0}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      )}
    </div>
  );
};

export default CampaignsTable;
